import { NavigationMenuLink } from '@/components/ui/navigation-menu';
import clsx from 'clsx';
import { FC } from 'react';

interface NavbarButtonProps {
  title: string;
  isActive?: boolean;
}

const NavbarButton: FC<NavbarButtonProps> = ({
  isActive,
  title,
}: NavbarButtonProps) => {
  return (
    <NavigationMenuLink
      className="h-10 px-4 py-2 gap-2.5 rounded-md"
      asChild
      active={isActive}
    >
      <p
        className={clsx('text-sm leading-6 font-medium', {
          'text-brand-600': isActive,
          'text-gray-600': !isActive,
        })}
      >
        {title}
      </p>
    </NavigationMenuLink>
  );
};

export default NavbarButton;
